module.exports = __webpack_public_path__ + "img/image.38dc50ca.jpg";